import { Injectable } from '@angular/core';
import { JeevesModalService } from 'gung-standard-jeeves';
import { Customer, CustomerContact } from 'gung-standard';
import { CultEditContactModalComponent } from '../components/cult-edit-contact-modal/cult-edit-contact-modal.component';
import { CultAddContactModalComponent } from '../components/cult-add-contact-modal/cult-add-contact-modal.component';

@Injectable({
  providedIn: 'root'
})
export class CultJeevesModalService extends JeevesModalService {
  openAddContactModal(contact: Customer) {
    this.modalRef = this.modalService.open(CultAddContactModalComponent, this.modalOptions);
    this.modalRef.componentInstance.contact = contact;
    this.modalRef.result.then(
      result => {},
      reason => {}
    );
  }

  openAddContactModalAsPromise(customer: Customer): Promise<any> {
    this.modalRef = this.modalService.open(CultAddContactModalComponent, this.modalOptions);
    this.modalRef.componentInstance.contact = customer;
    return this.modalRef.result;
  }

  openEditContactModal(customerContact: CustomerContact) {
    this.modalRef = this.modalService.open(CultEditContactModalComponent, this.modalOptions);
    this.modalRef.componentInstance.customerContact = customerContact;
    this.modalRef.result.then(
      result => {},
      reason => {}
    );
  }
}
